import { render, staticRenderFns } from "./cooperationType.vue?vue&type=template&id=dd3445c0&"
import script from "./cooperationType.vue?vue&type=script&lang=js&"
export * from "./cooperationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd3445c0')) {
      api.createRecord('dd3445c0', component.options)
    } else {
      api.reload('dd3445c0', component.options)
    }
    module.hot.accept("./cooperationType.vue?vue&type=template&id=dd3445c0&", function () {
      api.rerender('dd3445c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/cooperationType.vue"
export default component.exports